import { ArrayBase } from '../ArrayBase';

export class DMA extends ArrayBase {}
